var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisualsBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9899 78.6025H64.0102",
    stroke: "#70C4F0",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_278_15031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 93,
    height: 93
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91 91V2H2V91H91Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_278_15031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.0104 61.0891C64.0104 57.8674 61.3984 55.2554 58.1738 55.2554H34.8268C31.6019 55.2554 28.9901 57.8674 28.9901 61.0891V61.095C28.9901 64.3169 31.6019 66.9287 34.8268 66.9287H58.1738C61.3984 66.9287 64.0104 64.3169 64.0104 61.095V61.0891Z",
    stroke: "#70C4F0",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.827 55.2557L58.1738 66.9292",
    stroke: "#70C4F0",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1738 55.2549H34.827V52.3366C34.827 45.8897 40.0508 40.663 46.5003 40.663C52.9499 40.663 58.1738 45.8897 58.1738 52.3366V55.2549Z",
    stroke: "#70C4F0",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5002 26.0713C50.5275 26.0713 53.7961 29.3414 53.7961 33.3673C53.7961 37.3946 50.5275 40.6631 46.5002 40.6631C42.4728 40.6631 39.2042 37.3946 39.2042 33.3673C39.2042 29.3414 42.4728 26.0713 46.5002 26.0713Z",
    stroke: "#70C4F0",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6837 14.3986C75.6837 7.95199 70.4597 2.7251 64.0102 2.7251H28.99C22.5403 2.7251 17.3165 7.95199 17.3165 14.3986V78.6026C17.3165 85.0492 22.5403 90.2759 28.99 90.2759H64.0102C70.4597 90.2759 75.6837 85.0492 75.6837 78.6026V14.3986Z",
    stroke: "#70C4F0",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1738 2.72494H34.827V8.56178C34.827 11.785 37.4388 14.3984 40.6637 14.3984H52.3372C55.5619 14.3984 58.1738 11.785 58.1738 8.56178V2.72494Z",
    stroke: "#70C4F0",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualsBlue);
export default __webpack_public_path__ + "static/media/visuals-blue.0619709fdb5cdcb518cb605709f8c304.svg";
export { ForwardRef as ReactComponent };